import classNames from 'classnames';
import { IRepArea, StateModalStatus } from 'common/interfaces/state';
import { CardButton } from 'components/action';
import { SectionHeadline } from 'components/content';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./StateRepsList.css');
const arrowToRightIcon = require('assets/blue arrow.svg');

// Props
// tslint:disable-next-line:no-empty-interface
interface IStateRepsListProps extends IAppOnlyStore {}

// Component
@inject('store')
@observer
export class StateRepsList extends React.Component<IStateRepsListProps, {}> {
    @computed
    private get allReps(): IRepArea[] {
        return this.props.store.state.repsAreas;
    }

    @computed
    private get allRepsCount(): number {
        return this.allReps.length;
    }

    @computed
    private get repsSearchQuery(): string {
        return this.props.store.state.repsSearch.trim().toLowerCase();
    }

    @computed
    private get reps(): IRepArea[] {
        return this.allReps.filter(rep =>
            rep.name.toLowerCase().indexOf(this.repsSearchQuery) !== -1 ||
            rep.slpcode.toString() === this.repsSearchQuery ||
            rep.username.toLowerCase().indexOf(this.repsSearchQuery) !== -1
                ? true
                : false
        );
    }

    public render() {
        return (
            <div className={s.container}>
                <div className={s.header}>
                    <SectionHeadline
                        className={s.headline}
                        title={`${this.allRepsCount} active sales reps`}
                        button={{
                            onClick: this.handleGoingToAreasList,
                            icon: arrowToRightIcon,
                            iconClassName: s.assignIcon,
                            label: 'Assign reps to areas',
                            showLabel: true,
                        }}
                    />
                </div>

                {(this.reps.length > 0 && (
                    <div
                        className={classNames(s.repsList, {
                            [s.oneResult]: this.reps.length === 1,
                            [s.twoResults]: this.reps.length === 2,
                            [s.threeResults]: this.reps.length === 3,
                        })}
                    >
                        {this.reps.map(rep => {
                            const statesLabel =
                                rep.statesCount +
                                ' state' +
                                (rep.statesCount > 1 ? 's' : '');
                            const areasLabel =
                                rep.areasCount +
                                ' area' +
                                (rep.areasCount > 1 ? 's' : '');

                            return (
                                <CardButton
                                    key={rep.username}
                                    className={s.repButton}
                                    isDisabled={rep.areasCount <= 0}
                                    onClick={this.handleRepClick(rep)}
                                >
                                    <p className={s.repName}>{rep.name}</p>
                                    <p className={s.repAreasCount}>
                                        <strong>{statesLabel}</strong>

                                        {rep.areasCount > 0 && (
                                            <span>
                                                {'(' + areasLabel + ')'}
                                            </span>
                                        )}
                                    </p>
                                </CardButton>
                            );
                        })}
                    </div>
                )) || (
                    <div className={classNames(s.repsList, s.empty)}>
                        <p>No sales reps have been found.</p>
                    </div>
                )}
            </div>
        );
    }

    @action
    private handleGoingToAreasList = (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        this.props.store.state.modalStatus = StateModalStatus.OpenOnStatesList;
    };

    @action
    private handleRepClick = (rep: IRepArea) => (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        this.props.store.state.selectedRep = {
            id: rep.userId,
            slpcode: rep.slpcode,
            username: rep.username,
            name: rep.name,
        };

        this.props.store.state.modalStatus =
            StateModalStatus.OpenOnSpecificRepArea;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/StateRepsList.tsx